import { createContext, useContext, useEffect, useReducer } from "react";

import axios from "../../api/axios";
import { STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities";
import {
  testsReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/testsReducer";
import { useActionsTest } from "./TestFormProvider";
import { useNavigate } from "react-router-dom";
const TestIndexContext = createContext({});
const TestIndexProvider = ({ children }) => {
  const [state, dispatch] = useReducer(testsReducer, INITIAL_STATE);
  const actionsTest = useActionsTest();
  let navigate = useNavigate();
  useEffect(() => {
    if (state.tests.status === STATUS_NOT_LOADED) {
      axios()
        .get(`inventory/getTests`,{
          params:state.filter
        })
        .then(({ data }) => {
          dispatch({
            type: types.SET_TESTS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    }
  }, [state.tests.status,state.filter]);
  useEffect(() => {
    axios()
    .get(`general/getHeadquarters`)
    .then(({ data }) => {
      dispatch({
        type: types.SET_HEADQUARTERS_LOADED,
        payload: data,
      });
    })
    .catch((e) => {
      showTypeErrorFetch(e);
    });
  }, [state.headquarters.status])
  
  const updateFieldTest = (test_id, form) => {
    axios()
      .post(`inventory/test/${test_id}`, form)
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_TESTS
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const goToTest = (item_id) => {
    actionsTest.loadTest(item_id);
    navigate("/inventory/test");
  };
  return (
    <TestIndexContext.Provider value={[state, dispatch, { goToTest,updateFieldTest }]}>
      {children}
    </TestIndexContext.Provider>
  );
};
const useTests = () => useContext(TestIndexContext)[0];
const useDispatchTestIndex = () => useContext(TestIndexContext)[1];
const useActionsTests = () => useContext(TestIndexContext)[2];

export { TestIndexContext, useTests, useDispatchTestIndex, useActionsTests };
export default TestIndexProvider;
